import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ChevronDown, Globe } from 'lucide-react';
import '../styles/LanguageSelector.css';

const LanguageSelector = () => {
  const { language, changeLanguage, languageInfo, availableLanguages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (lang) => {
    changeLanguage(lang);
    setIsOpen(false);
  };

  const currentLang = languageInfo[language];

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button 
        className="language-selector-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select language"
      >
        <Globe size={18} className="globe-icon" />
        <span className="current-lang-flag">{currentLang.flag}</span>
        <span className="current-lang-short">{currentLang.short}</span>
        <ChevronDown size={14} className={`chevron ${isOpen ? 'rotate' : ''}`} />
      </button>

      {isOpen && (
        <div className="language-dropdown">
          <div className="dropdown-header">
            <Globe size={16} />
            <span>Select Language</span>
          </div>
          {availableLanguages.map((lang) => (
            <button
              key={lang}
              className={`language-option ${language === lang ? 'active' : ''}`}
              onClick={() => handleSelect(lang)}
            >
              <span className="lang-flag">{languageInfo[lang].flag}</span>
              <span className="lang-name">{languageInfo[lang].name}</span>
              {language === lang && (
                <span className="check-mark">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
